<div class="form-group" [class.mb-0]="noMb" [formGroup]="customFormGroup">
  <label [class.sr-only]="hideLabel" [for]="'input-' + id" [id]="'sfklabel-'+id" data-cy="custom-label">
    {{ label }}
  </label>
  @if (!!infoText && infoText.length > 0) {
    <fa-icon class="infoIcon"
      [icon]="faInfo"
      [title]="infoText"
      data-cy="custom-info"
    ></fa-icon>
  }
  @if (environment.displayTextbausteinKeys) {
    <span>{{infoText}}</span>
  }
  <div style="position:relative;">
    @if (showMaxLength) {
      <div class="position-absolute" style="right: 5px; top: 2px;">
        <span
          [class.text-muted]="currentLength / maxReferenceLength < 0.6"
        [class.text-warning]="
					currentLength / maxReferenceLength >= 0.6 && currentLength / maxReferenceLength < 1
				"
          [class.text-danger]="currentLength / maxReferenceLength >= 1"
          >
          {{ c(id).value.length }}/{{ maxReferenceLength }}
        </span>
      </div>
    }
    <div class="input-group">
      @if (extra_field_text) {
        <div class="input-group-prepend input-currency-field">
          <span class="input-group-text justify-content-center">{{extra_field_text}}</span>
        </div>
      }
      @if (extra_field_icon) {
        <div class="input-group-prepend input-currency-field">
          <span class="input-group-text justify-content-center"><fa-icon [icon]="extra_field_icon"></fa-icon>
        </span>
      </div>
    }
    <input #input
      [type]="type"
      class="form-control"
      [id]="'input-' + id"
      [placeholder]="placeholder"
      [formControlName]="id"
      [readOnly]="readonly"
      [disabled]="disabled"
      [step]="step"
      [min]="min"
      [max]="max"
      [maxlength]="maxlength"
      [pattern]="pattern"
      (change)="triggerOnChange($event)"
      [accept]="acceptFormats"
      [appGermanDecimal] = numDigits
      [nullable]="nullable"
      data-cy="custom-input"
      />
      @if (clearable && input.value) {
        <button type="button" class="btn-outline-secondary btn-clear"
          aria-label="Clear" (click)="input.value=''; triggerOnClear($event); ">
          <fa-icon [icon]="faX" (click)="input.value=''"></fa-icon>
        </button>
      }
    </div>
  </div>

  @if (c(id)?.invalid && (c(id)?.dirty || c(id).touched)) {
    <small
      [id]="id + 'HelpBlock'"
      class="form-text text-muted"
      >
      {{ noteText }}
    </small>
  }
  @if (c(id)?.invalid && (c(id)?.dirty || c(id).touched) && max !== null && max !== undefined) {
    <small
      [id]="id + 'HelpBlock'"
      class="form-text text-muted"
      >
      Der maximale Wert für dieses Feld beträgt {{ max }}. Bitte tragen Sie einen kleineren Wert ein.
    </small>
  }
</div>
